import React from "react";
import { Button, Tag, Tooltip } from "antd";
import {
    PrinterOutlined,
    CameraOutlined,
    EyeOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import moment from "moment";

export const columnNames = () => [
    { label: "Огноо", value: "currentDate" },
    { label: "Овог нэр", value: "customerFirstname" },
    { label: "Регистр", value: "regno" },
    { label: "Нас", value: "age" },
    { label: "Хүйс", value: "gender" },
    { label: "Утас", value: "answerPhone" },
    { label: "Зовиур", value: "painful" },
    { label: "Үйлчилгээ", value: "serviceNames" },
    { label: "Төхөөрөмж", value: "serviceTypeName" },
    { label: "Эмч", value: "doctor" },
    { label: "Техникч", value: "technicalUser" },
    { label: "Ресейпшн", value: "reception" },
    { label: "Tag", value: "tags" },
    { label: "Хэвлэх", value: "print" },
    { label: "Зураг", value: "image" },
];

const highlight = (text, searchText) => {
    if (!text) return "";
    if (!searchText) return text;
    return (
        <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={String(text)}
        />
    );
};

export default ({
    currentPage = 0,
    searchText = "",
    hiddenColumns = [],
    handleMore,
    openPrint,
    openImage,
}) => {
    const isHidden = (key) => hiddenColumns.includes(key);

    return [
        {
            title: "№",
            key: "No",
            width: 55,
            fixed: "left",
            align: "center",
            render: (_, __, i) => <span>{currentPage + i + 1}</span>,
        },
        {
            title: "Огноо",
            dataIndex: "currentDate",
            key: "currentDate",
            width: 130,
            fixed: "left",
            visible: !isHidden("currentDate"),
            render: (text) => (
                <span className="text-xs">
                    {text ? moment(text).format("YYYY-MM-DD HH:mm") : ""}
                </span>
            ),
        },
        {
            title: "Овог нэр",
            dataIndex: "customerFirstname",
            key: "customerFirstname",
            width: 160,
            fixed: "left",
            visible: !isHidden("customerFirstname"),
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Регистр",
            dataIndex: "regno",
            key: "regno",
            width: 110,
            visible: !isHidden("regno"),
            render: (text) => highlight(text, searchText),
        },
        {
            title: "Нас",
            dataIndex: "age",
            key: "age",
            width: 60,
            visible: !isHidden("age"),
        },
        {
            title: "Хүйс",
            dataIndex: "gender",
            key: "gender",
            width: 70,
            visible: !isHidden("gender"),
            render: (g) => (
                <Tag color={g == 1 ? "green" : "pink"}>{g == 1 ? "Эр" : "Эм"}</Tag>
            ),
        },
        {
            title: "Утас",
            dataIndex: "answerPhone",
            key: "answerPhone",
            width: 110,
            visible: !isHidden("answerPhone"),
        },
        {
            title: "Зовиур",
            dataIndex: "painful",
            key: "painful",
            width: 240,
            visible: !isHidden("painful"),
            render: (text) => (
                <Tooltip title={text} placement="topLeft">
                    <div className="line-clamp-2 text-xs">
                        {highlight(text, searchText)}
                    </div>
                </Tooltip>
            ),
        },
        {
            title: "Үйлчилгээ",
            dataIndex: "serviceNames",
            key: "serviceNames",
            width: 200,
            visible: !isHidden("serviceNames"),
            render: (text) => (
                <Tooltip title={text} placement="topLeft">
                    <div className="line-clamp-2 text-xs">{text}</div>
                </Tooltip>
            ),
        },
        {
            title: "Төхөөрөмж",
            dataIndex: "serviceTypeName",
            key: "serviceTypeName",
            width: 100,
            visible: !isHidden("serviceTypeName"),
        },
        {
            title: "Эмч",
            dataIndex: "doctor",
            key: "doctor",
            width: 120,
            visible: !isHidden("doctor"),
        },
        {
            title: "Техникч",
            dataIndex: "technicalUser",
            key: "technicalUser",
            width: 120,
            visible: !isHidden("technicalUser"),
        },
        {
            title: "Ресейпшн",
            dataIndex: "reception",
            key: "reception",
            width: 120,
            visible: !isHidden("reception"),
        },
        {
            title: "Tag",
            key: "tags",
            width: 180,
            visible: !isHidden("tags"),
            render: (_, row) => (
                <div className="flex flex-wrap gap-1">
                    {row.isCe ? <Tag color="purple">CE</Tag> : null}
                    {row.isAns ? <Tag color="blue">Унтуулга</Tag> : null}
                    {row.urgent ? <Tag color="red">Яаралтай</Tag> : null}
                    {row.isRepeat ? <Tag color="orange">Давтан</Tag> : null}
                    {row.insurance ? <Tag color="green">ЭМД</Tag> : null}
                    {row.isEnglishResponse ? <Tag color="cyan">EN</Tag> : null}
                    {row.isBonus ? <Tag color="gold">Bonus</Tag> : null}
                </div>
            ),
        },
        {
            title: "Үйлдэл",
            key: "actions",
            width: 130,
            fixed: "right",
            align: "center",
            render: (_, row) => (
                <div className="flex items-center gap-2 justify-center">
                    <Tooltip title="Дэлгэрэнгүй">
                        <Button
                            size="small"
                            icon={<EyeOutlined />}
                            onClick={() => handleMore && handleMore(row)}
                        />
                    </Tooltip>
                    <Tooltip title="Хэвлэх">
                        <Button
                            size="small"
                            icon={<PrinterOutlined />}
                            onClick={() => openPrint && openPrint(row)}
                        />
                    </Tooltip>
                    <Tooltip title="Зураг">
                        <Button
                            size="small"
                            className={
                                row.bookingimages?.length > 0
                                    ? "border-green-500 text-green-600"
                                    : ""
                            }
                            icon={<CameraOutlined />}
                            onClick={() => openImage && openImage(row.id)}
                        />
                    </Tooltip>
                </div>
            ),
        },
    ];
};